import classNames from "classnames";
import React from "react";
import style from "./Button.module.css";

interface ButtonProps {
  children: any;
  type?: any;
  onClick?: any;
  variant?: "primary" | "secondary";
  disabled?: boolean;
  className?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant, ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        className={classNames(
          style.buttonElement,
          {
            [style.secondary]: variant === "secondary",
          },
          props.className
        )}
      >
        {children}
      </button>
    );
  }
);
export default Button;
